/* ============================================================
   WORDS — 全ページ共通スクリプト
   2026-09-03 リデザインに伴い整理。
   ヘッダー／ハンバーガー／検索／カルーセル／波の処理は
   すべて新実装（words-header.js ほか）へ移ったのでここからは削除した。
   旧版は _backup/20260903_pagescss/words-common.js にある。
   ============================================================ */
(function () {
  /* ---------- 翻訳ボタン：今見ているページをGoogle翻訳で開く ---------- */
  function goTranslate(lang) {
    var url = 'https://translate.google.com/translate?sl=ja&tl=' + encodeURIComponent(lang) +
              '&u=' + encodeURIComponent(window.location.href);
    window.open(url, '_blank', 'noopener');
  }
  document.querySelectorAll('[data-lang]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      goTranslate(el.getAttribute('data-lang'));
    });
  });

  /* ---------- 横スクロール列をマウスで掴んで動かす ----------
     タッチ端末はブラウザ標準のスワイプに任せる（pointerType で除外）。 */
  var drag = { el: null, x: 0, left: 0, moved: false };
  var SEL = '.pd-thumbs, .pd-gal__track, [data-drag-scroll]';

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var tr = e.target.closest && e.target.closest(SEL);
    if (!tr || tr.scrollWidth <= tr.clientWidth) return;
    drag.el = tr; drag.x = e.clientX; drag.left = tr.scrollLeft; drag.moved = false;
    tr.classList.add('dragging');
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag.el) return;
    var dx = e.clientX - drag.x;
    if (Math.abs(dx) > 6) drag.moved = true;
    drag.el.scrollLeft = drag.left - dx;
  });
  document.addEventListener('pointerup', function () {
    if (!drag.el) return;
    drag.el.classList.remove('dragging');
    var wasMoved = drag.moved, el = drag.el;
    drag.el = null;
    if (wasMoved) {
      /* ドラッグ直後のクリックでリンクへ飛ばないよう1回だけ抑止 */
      var stop = function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        el.removeEventListener('click', stop, true);
      };
      el.addEventListener('click', stop, true);
      setTimeout(function () { el.removeEventListener('click', stop, true); }, 80);
    }
  });
})();
